import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "../data/site";

/**
 * Injects Google Analytics 4 and Meta Pixel (only when IDs are set in SITE.analytics).
 * Also:
 *  - fires a page_view on every route change
 *  - listens for form submissions to /api/leads → tracks `generate_lead`
 *  - listens for wa.me clicks anywhere in the app → tracks `whatsapp_click`
 */
export default function Analytics() {
    const { pathname } = useLocation();
    const ga4 = SITE.analytics?.ga4MeasurementId;
    const pixel = SITE.analytics?.metaPixelId;

    // Inject snippets once
    useEffect(() => {
        if (ga4 && !window.__ga4Injected) {
            const s = document.createElement("script");
            s.async = true;
            s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
            document.head.appendChild(s);
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
                window.dataLayer.push(arguments);
            };
            window.gtag("js", new Date());
            window.gtag("config", ga4);
            window.__ga4Injected = true;
        }
        if (pixel && !window.__pixelInjected) {
            /* eslint-disable */
            !(function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod
                        ? n.callMethod.apply(n, arguments)
                        : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = "2.0";
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(
                window,
                document,
                "script",
                "https://connect.facebook.net/en_US/fbevents.js",
            );
            /* eslint-enable */
            window.fbq("init", pixel);
            window.fbq("track", "PageView");
            window.__pixelInjected = true;
        }
    }, [ga4, pixel]);

    // Page view on route change
    useEffect(() => {
        if (window.gtag && ga4) {
            window.gtag("event", "page_view", { page_path: pathname });
        }
        if (window.fbq && pixel) {
            window.fbq("track", "PageView");
        }
    }, [pathname, ga4, pixel]);

    // Delegate WhatsApp click tracking
    useEffect(() => {
        const onClick = (e) => {
            const link = e.target.closest("a");
            if (!link) return;
            const href = link.getAttribute("href") || "";
            if (href.includes("wa.me/")) {
                if (window.gtag) {
                    window.gtag("event", "whatsapp_click", {
                        event_category: "engagement",
                        event_label: pathname,
                    });
                }
                if (window.fbq) window.fbq("track", "Contact");
            }
        };
        document.addEventListener("click", onClick);
        return () => document.removeEventListener("click", onClick);
    }, [pathname]);

    return null;
}

/** Utility helper called from Contact form on successful submit */
export function trackLead(payload = {}) {
    if (typeof window === "undefined") return;
    if (window.gtag) {
        window.gtag("event", "generate_lead", {
            event_category: "form",
            currency: "MUR",
            ...payload,
        });
    }
    if (window.fbq) {
        window.fbq("track", "Lead", { currency: "MUR", ...payload });
    }
}
